export const isInt = (value) => {
  return !isNaN(value) && !isNaN(parseInt(value, 10));
}

export const isSearchKeyValid = (value) => {
  return isInt(value) && (parseInt(value) <= 9999999) && (parseInt(value) >= 1000000)
}